import { PmsReferralComponent } from 'app/components/pms-referral/PmsReferralComponent'
import { usePmsReferral } from 'app/components/pms-referral/usePmsReferral'

export default function ChannelMappingPage(): React.ReactElement {
  const hookData = usePmsReferral()
  return <PmsReferralComponent {...hookData} />
}
